import iconMC from '../assets/icons/icon-mc.svg';
import iconDiscover from '../assets/icons/discover.png';
import iconVisa from '../assets/icons/icon-visa.svg';
import React from 'react';
import styled from 'styled-components';
import ImgThemed from '@/components/ImgThemed/ImgThemed';

const DiscoverContainer = styled.div`
    display: flex;
    img {
        width: 34px;
        height: 24px;
    }
`;

const SchemeLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const returnCardSchemeIcon = (scheme?: string) => {
    if (!scheme) return null;
    switch (scheme.toLowerCase()) {
        case 'mastercard':
            return <ImgThemed src={iconMC} alt="mastercard" />;
            break;
        case 'visa':
            return <ImgThemed src={iconVisa} alt="visa" />;
            break;
        case 'discover':
            return (
                <DiscoverContainer>
                    <ImgThemed src={iconDiscover} alt="discover" />
                </DiscoverContainer>
            );
            break;
        default:
            return null;
    }
};

export const returnCardSchemeIconAndLabel = (scheme?: string) => {
    if (!scheme) return null;
    switch (scheme.toLowerCase()) {
        case 'mastercard':
            return (
                <SchemeLabelContainer>
                    {returnCardSchemeIcon('mastercard')}
                    Mastercard
                </SchemeLabelContainer>
            );
            break;
        case 'visa':
            return <SchemeLabelContainer>{returnCardSchemeIcon('visa')} Visa</SchemeLabelContainer>;
            break;
        case 'discover':
            return (
                <SchemeLabelContainer>
                    {returnCardSchemeIcon('discover')}
                    Discover
                </SchemeLabelContainer>
            );
            break;
        default:
            return '';
    }
};

export const returnCardSchemaOptionsForSelectorWithIconAndLabel = (schemeList?: string[]) => {
    if (!schemeList || schemeList.length < 1) return [];
    return schemeList.map((scheme) => {
        switch (scheme.toLowerCase()) {
            case 'mastercard':
                return {
                    value: 'mastercard',
                    label: (
                        <SchemeLabelContainer>
                            {returnCardSchemeIcon('mastercard')}
                            Mastercard
                        </SchemeLabelContainer>
                    ),
                };
                break;
            case 'visa':
                return {
                    value: 'visa',
                    label: (
                        <SchemeLabelContainer>
                            {returnCardSchemeIcon('visa')} Visa
                        </SchemeLabelContainer>
                    ),
                };
                break;
            case 'discover':
                return {
                    value: 'discover',
                    label: (
                        <SchemeLabelContainer>
                            {returnCardSchemeIcon('discover')}
                            Discover
                        </SchemeLabelContainer>
                    ),
                };
                break;
            default:
                return {};
        }
    });
};
